import {払出修正候補検索結果レコード型} from '@/type/withdrawal/records/modify/払出修正候補検索結果レコード型';
import moment from 'moment';

export class 払出修正候補編集レコード型 {

  static 作成する(部署コード: string, record: 払出修正候補検索結果レコード型): 払出修正候補編集レコード型 {
    return new 払出修正候補編集レコード型(
      false,
      部署コード,
      record.払出日,
      record.払出箱数,
      record.払出バラ数,
      record,
    );
  }

  確定対象: boolean;
  部署コード: string;
  払出日: Date | null;
  払出箱数: number;
  払出バラ数: number;
  元レコード: 払出修正候補検索結果レコード型;

  constructor(確定対象: boolean, 部署コード: string, 払出日: Date | null, 払出箱数: number, 払出バラ数: number, 元レコード: 払出修正候補検索結果レコード型) {
    this.確定対象 = 確定対象;
    this.部署コード = 部署コード;
    this.払出日 = 払出日;
    this.払出箱数 = 払出箱数;
    this.払出バラ数 = 払出バラ数;
    this.元レコード = 元レコード;
  }

  修正されている(): boolean {
    if (!moment(this.払出日).isSame(this.元レコード.払出日, 'day')) return true;
    if (this.払出箱数 !== this.元レコード.払出箱数) return true;
    if (this.払出バラ数 !== this.元レコード.払出バラ数) return true;
    return false;
  }
}

export function 確定対象をフィルタする(list: 払出修正候補編集レコード型[]): 払出修正候補編集レコード型[] {
  return list.filter((value) => value.確定対象);
}
